var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"is-guest-route":""}}),_c('CookiesAlert'),_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }